import { Component } from '@angular/core';

@Component({
    selector   : 'fuzz-demo-sidebar',
    templateUrl: './demo-sidebar.component.html',
    styleUrls  : ['./demo-sidebar.component.scss']
})
export class FuseDemoSidebarComponent
{
    /**
     * Constructor
     */
    constructor()
    {
    }
}
